import {
  AbstractControlOptions,
  UntypedFormArray,
  Validators,
} from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';

import { FormConfig } from '@app/forms/subscription/definition/types/subscription';
import {
  PledgeRead,
  Parameters,
  ClientAdequation,
} from '@app/forms/subscription/definition/interface/Pledge';
import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { SubscriptionFacadeService } from '../../services/subscription-facade.service';
@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  constructor(
    protected formConstructor: PrFormConstructor,
    protected subscriptionFacade: SubscriptionFacadeService,
  ) {
    super(formConstructor);
  }
  generate(entity: PledgeRead) {
    const parameters: Parameters = {
      ...entity?.parameters,
    };
    let options: AbstractControlOptions = {};
    const formConfig: FormConfig<ClientAdequation> = {
      clientAdequation: [
        parameters?.clientAdequation || null,
        Validators.required,
      ],
    };
    return this.formBuilder.group(formConfig, options);
  }

  get owners() {
    return this.form.get('owners') as UntypedFormArray;
  }

  extract() {
    return { ...this.form.value };
  }
}
